import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const UserGroupPopup = withSafeSuspense(lazy(
  async () => ({ default: (await import('./user_group_popup')).UserGroupPopup })
), null)
